import { render, staticRenderFns } from "./InputSuit.vue?vue&type=template&id=1788a049&scoped=true&"
import script from "./InputSuit.vue?vue&type=script&lang=js&"
export * from "./InputSuit.vue?vue&type=script&lang=js&"
import style0 from "./InputSuit.vue?vue&type=style&index=0&id=1788a049&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1788a049",
  null
  
)

export default component.exports